import { render, staticRenderFns } from "./amaIndex.vue?vue&type=template&id=6c8da207&scoped=true"
import script from "./amaIndex.vue?vue&type=script&lang=js"
export * from "./amaIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8da207",
  null
  
)

export default component.exports